import { render, staticRenderFns } from "./AbSelect.vue?vue&type=template&id=39b0098e&scoped=true&"
import script from "./AbSelect.vue?vue&type=script&lang=ts&"
export * from "./AbSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0098e",
  null
  
)

export default component.exports